// A tab's session takes precedence over a remembered session from another tab.
export const getAuthToken = () =>
  sessionStorage.getItem("token") || localStorage.getItem("token");

export const clearAuthStorage = () => {
  for (const storage of [sessionStorage, localStorage]) {
    for (const key of ["token", "userId", "userRole"]) storage.removeItem(key);
  }
};

export const storeAuthToken = (token, rememberMe = true) => {
  // Shared by default for native new tabs; expiry is still enforced by the JWT.
  // Do not briefly remove the shared token when replacing it: other tabs would
  // interpret that intermediate storage event as a logout.
  (rememberMe ? sessionStorage : localStorage).removeItem("token");
  for (const storage of [sessionStorage, localStorage]) {
    storage.removeItem("userId");
    storage.removeItem("userRole");
  }
  (rememberMe ? localStorage : sessionStorage).setItem("token", token);
};
